import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styles from "@/routes/lms/lmsCourseOverview.module.css";

interface Props {
  className?: string;
  disabled?: boolean;
}

export default function LmsBackButton({
  className,
  disabled = false,
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={[styles.backButton, className].filter(Boolean).join(" ")}
      onClick={() => navigate(-1)}
      disabled={disabled}
    >
      <span className={styles.backButtonIconWrap} aria-hidden>
        <NavigateBeforeIcon className={styles.backButtonIcon} />
      </span>
      {t("back")}
    </button>
  );
}
